import { loading, toast } from '@/shared/utils/UIHelper'
import ClienteRHRepository from '@/shared/http/repositories/business/clientrh.js'
import ObraRepository from '@/shared/http/repositories/business/obrarh.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import AccountRepository from '@/shared/http/repositories/access/account.js'

const BoardMixin = {
  methods: {
    onSearchClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetByCode(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchObra (value) {
      loading.push()
      ObraRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.obraRHTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeObra (value) {
      loading.push()
      ObraRepository.GetByCode(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.obraRHTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchResponsavel (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeResponsavel (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchFavorecido (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFavorecidoCheckAccount (value) {
      this.onChangeCodeFavorecido(value, true)
    },
    onChangeCodeFavorecido (value, checkAccount) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.setValue(response.data.data)
            if (checkAccount) {
              this.onCheckEmployeeHasAccount(response.data.data.id)
            }
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onCheckEmployeeHasAccount (employeeId) {
      loading.push()
      AccountRepository.GetByEmployeeId(employeeId)
        .then((response) => {
          if (response.data.code > 0) {
            if (response.data.data == null) {
              toast.warning('<br> O Funcionário que irá receber o crédito não possui um conta para acesso ao sistema. <br><br> Informe ao TI para realizar o cadastro, por favor', 'DESPESAS DIVERSOS')
              this.$refs.favorecidoTypeahead.clear()
            }
            console.log(this.$refs.favorecidoTypeahead)
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    }
  }
}

export default BoardMixin



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/mixins/ExpenseMixin.js